/**
 * Determines whether a report should run immediately or be queued
 * based on the date range and configured threshold.
 *
 * @param {Date|null} startDate - Report start date
 * @param {Date|null} endDate - Report end date
 * @param {number} thresholdDays - Maximum days for immediate execution
 * @returns {'immediate' | 'queue'}
 */
export function computeRoutingDecision(startDate, endDate, thresholdDays) {
  if (!startDate || !endDate) return 'queue';

  const diffMs = endDate.getTime() - startDate.getTime();
  const diffDays = diffMs / (1000 * 60 * 60 * 24);

  return diffDays <= thresholdDays ? 'immediate' : 'queue';
}
